// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Editable from 'components/Editable/Editable'
import Link from 'components/Link/Link'
import { get, loop } from 'utilities/objects'

class ActivityMemoryVerse extends React.Component {
	render() {
		const { page, userCanEditPage } = this.props

		if ( ! page.memory_verse && ! userCanEditPage ) {
			return null
		}

		return (
			<section className="page-section">
				<div className="section-activity-content section-activity-memory-verse">
					<div className="-inner">
						<div className="-content">
							<div className="-title">
								<h2>Memory Verse</h2>
							</div>

							<div className="callout">
								<Editable
									id="activity_memory_verse"
									element="div"
									className="-text"
									content={ page.memory_verse }
								/>

								<Editable
									id="activity_memory_verse_reference"
									element="p"
									className="-ref"
									content={ page.memory_verse_reference }
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		userCanEditPage: siteData.current_user_can_edit_pages,
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( ActivityMemoryVerse )



// WEBPACK FOOTER //
// ./components/PageSections/ActivityMemoryVerse.jsx